<template>
  <el-dialog class="myTask"
             :visible.sync="myTaskVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             :modal-append-to-body="false"
             append-to-body
             width="1200px"
             title="我的任务">
    <status_tabs :status.sync="status"
                 :statusList="statusList"
                 :funcName="'tasks'"></status_tabs>
    <div class="searchCont">
      <div class="searchContLeft">
        <el-form :inline="true"
                 :model="searchForm"
                 label-width="120"
                 @submit.native.prevent @keydown.enter.native.prevent>
          <el-form-item label="ID"
                        size="small">
            <el-input v-model.number="searchForm.id"
                      @keyup.enter.native="tasks(1)"
                      maxlength="100"
                      placeholder="请输入ID"
                      size="small"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item size="small">
            <el-button icon="el-icon-search"
                       size="small"
                       type="primary"
                       style="margin-right:10px"
                       @click="tasks(1)"></el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tableCont">
      <el-table border
                :data="tableData"
                highlight-current-row
                stripe>
        <el-table-column width="60"
                         prop="id"
                         align="center"
                         label="ID">
        </el-table-column>
        <el-table-column label="任务名称"
                         property="title"
                         align="center">
          <template slot-scope="scope">
            <div style="text-align:left">
              <span>
                <span>产品：</span>
                <span class="font-color">{{scope.row.goods_name?scope.row.goods_name:'-'}}</span>,
              </span>
              <span>
                <span>SKU：</span>
                <span class="font-color">{{scope.row.sku?scope.row.sku:'-'}}</span>,
              </span>
              <span>
                {{scope.row.title}}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建人"
                         property="org_user_name"
                         align="center"
                         width="120">
        </el-table-column>
        <el-table-column label="指派人"
                         property="opt_user_name"
                         align="center"
                         width="120">
        </el-table-column>
        <el-table-column label="创建时间"
                         property="create_time"
                         align="center"
                         width="170">
        </el-table-column>
        <el-table-column label="完成时间"
                         property="last_update_time"
                         align="center"
                         width="170"
                         v-if="searchForm.status == '3'">
        </el-table-column>
        <el-table-column label="操作"
                         v-if="searchForm.status == '2'"
                         align="center"
                         width="150">
          <template slot-scope="scope">
            <el-button v-for="item in scope.row.authority"
                       :key="item.id"
                       type="text"
                       size="small"
                       class="color-blue"
                       :class="item.class"
                       @click="rowDo(scope.row, item)">{{ item.name }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :paginationData="paginationData"
                  @paginationChange="paginationChange"></pagination>
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 @click="myTaskVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import * as erpApi from "@/http/erpApi.js";
import pagination from "@/common/components/pagination";
import status_tabs from "@/common/components/table/status_tabs";
export default {
    data() {
        return {
            defaultActive: 0,
            searchForm: {
                id: "",
            },
            status: "2",
            tableData: [],

            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },
            statusList: [
                { name: "待处理", status: "2", total: "" },
                { name: "已完成", status: "3", total: "" },
            ],
            tableItem: {},

            goodsDevelopVisible: false,
            goodsDevelopDetailVisible: false,

            goodsOpenVisible: false,
            goodsOpenDetailVisible: false,

            supplierQuotationVisible: false,
            supplierQuotationDetailVisible: false,

            goodsSampleVisible: false,
            goodsSampleDetailVisible: false,

            goodsDesignVisible: false,
            goodsDesignDetailVisible: false,

            goodsCompleteVisible: false,
            goodsCompleteDetailVisible: false,

            goodsInfoVisible: false,
            goodsInfoDetailVisible: false,

            goodsTestVisible: false,
            goodsTestDetailVisible: false,
            tableItem: {},
        };
    },
    methods: {
        /**
         * 获取商店table
         */
        tasks(page) {
            page ? (this.paginationData.page = 1) : "";
            erpApi
                .tasks(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.statusList = res.ext.tabs;
                        this.paginationData.total = res.total;
                    }
                });
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.tasks();
        },
        /**
         * 根据table数据循环事件分发
         */
        rowDo(row, item) {
            if (item.name == "认领") {
                erpApi
                    .tasksRecept(
                        {
                            id: row.id,
                        },
                        "post"
                    )
                    .then((res) => {
                        if (res) {
                            this.$message.success("认领成功");
                            this.tasks();
                        }
                    });
            } else if (item.name == "处理") {
                if (row.is_view == 0) {
                    row.module = row.module.replace(
                        row.module[0],
                        row.module[0].toLowerCase()
                    );
                    this[`${row.module}Visible`] = true;
                    this.tableItem = row;
                } else if (row.is_view == 1) {
                    row.module = row.module.replace(
                        row.module[0],
                        row.module[0].toLowerCase()
                    );
                    this[`${row.module}DetailVisible`] = true;
                    this.tableItem = row;
                }
            } else if (item.name == "释放") {
                this.$confirm(`确定${item.name}?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        erpApi[
                            `${row.module.replace(
                                row.module[0],
                                row.module[0].toLowerCase()
                            )}_release`
                        ](
                            {
                                id_list: [row.task_id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res.code == 200) {
                                    this.tasks();
                                    this.$message.success("操作成功");
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("已取消操作");
                    });
            }
        },
        authFunc(funcName) {
            this[funcName]();
        },
        closeDialog() {
            this.tableData = [];
            this.$emit("update:myTaskVisible", false);
        },
    },
    components: {
        pagination: pagination,
        status_tabs: status_tabs,
    },
    computed: {
        staffList() {
            return this.$store.state.index.staffList;
        },
        screen() {
            return `calc(100% - 40px - 40px)`;
        },
    },
    props: {
        myTaskVisible: Boolean,
    },
    watch: {
        myTaskVisible: {
            handler(newV) {
                if (newV) {
                    this.tasks();
                }
            },
            deep: true,
            immediate: false,
        },
    },
};
</script>
<style lang="scss">
.myTask {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .tableCont {
        width: 100%;
        .table {
            width: 100%;
            .el-scrollbar__wrap {
                overflow-x: hidden;
            }
        }
        .font-color {
            color: $color-primary;
        }
    }
}
</style>
